module.exports = __webpack_public_path__ + "img/1.fed89136.png";